export enum FilterPropertyPayloadType {
  Static = 'static',
  Dynamic = 'dynamic',
}
